module.exports = __webpack_public_path__ + "static/media/Stripe_BG.40afccb3.svg";